import CircularProgress from '@mui/material/CircularProgress'

export default function Loading({ ...props }) {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircularProgress {...props} />
    </div>
  )
}
